
import React,{useState, useEffect} from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { Layout, Col, Row, Divider, Input, Drawer, Collapse, List } from 'antd';
import { 
  ShoppingOutlined, 
  MenuOutlined,
  CloseOutlined,
  ArrowRightOutlined, 
  PlusOutlined,
  
  InstagramOutlined, 
  FacebookFilled, 
  YoutubeFilled, 
  TikTokOutlined 
} from '@ant-design/icons';

import CardDom from '../CardDom/CardDom';

import { getProductList } from '../../api/goods'
import { getBlogList } from '../../api/article'

import './BaseLayout.less'

const { Header, Footer } = Layout;
const headerStyle = {
  width: '100%',
  height: 64,
  padding: '0 30px',
  color: '#000',
  textAlign: 'center',    
  lineHeight: '24px',
  background: "#fff",
  display: 'flex',
  alignItem:"center",
  justifyContent: 'center',
  position:'relative',
  zIndex: 999,
};
const footerStyle = {
  width:'100%',
  padding: '0 1%',
  textAlign: 'center',
  color: '#272724',
  background: '#fff'
};
const BaseLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login'; // 判断当前是否是登录页

  const [width, setWidth] = useState(window.innerWidth);
  const [open, setOpen] = useState(false);
  const [selectBtn, setSelectBtn] = useState('')
  const [openDetailBox, setOpenDetailBox] = useState(false)
  const [detailBoxStyle, setDetailBoxStyle] = useState({})
  const [headerBtnList, setHeaderBtnList] = useState([
    {
      name: '商品',
      link: '/shop',
      childrens: [
        {name: '全部商品',link: '/shop'},
        {name: '补充剂',link: '/shop'},
        // {name: 'Bundles',link: '/shop'}
      ],
      list: [{
        type: 'goods',
        content:{
          title: 'Mitopure Softgels',
          description: 'The simplest form of Mitopure',
          img: require('../../image/shop1-1200x1200.avif'),
          imgHover: require('../../image/shop1-hover-1600x1600.avif'),
          // star: 4.4,
          // commentCount: 2813,
          bestseller: false,
          tag: false
        },
        btnConfig:{
          link:'/shopDetail',
        }
      },{
        type: 'goods',
        content:{
          title: 'The Day Cream',
          description: "Redensifies the skin's appearance. Powered by Mitopure®",
          img: require('../../image/shop2-1200x1200.avif'),
          imgHover: require('../../image/shop2-hover-1600x1600.avif'),
          // star: 4.4,
          // commentCount: 2813,
          bestseller: false,
          tag: false
        },
        btnConfig:{
          link:'/shopDetail',
        }
      }]
    },
    {
      name: '科学',
      link: '/science',
      childrens: [
        {name:'科学',link: '/science'},
        {name:'研究',link: '/studies'},
        // {name:'前往科学',link: '/science'},
        // {name:'Studies',link: '/science'}
      ],
      list: [{
        type: 'img',
        content: {
          title: '对身体的益处',
          img: <img src={require('../../image/sticky-img.webp')} style={{width: '100%',borderRadius:5}}/>,
          list: [],
        },
        btnConfig: {
          icon: 'ArrowRightOutlined',
          link: '/science'
        }
      },{
        type: 'img',
        content: {
          title: '前往科学',
          img: <img src={require('../../image/bigCardBg2-1200x964.png')} style={{width: '100%',borderRadius:5}}/>,
          list: [],
        },
        btnConfig: {
          icon: 'ArrowRightOutlined',
          link: '/science'
        }
      }]
    },
    {
      name: '关于',
      link: '/Blog',
      childrens: [
        {name:'论文',link: '/Blog'},
        // {name:'Reviews',link: '/Reviews'},
        // {name:'Testimonials',link: '/Testimonials'},
        // {name:'Patents',link: '/Patents'}
      ],
      list:[{
        type: 'img2',
        content: {
          img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
          title: 'New Study: Mitopure Improves Muscle Health in Athletes',
          taglist: ['News', 'Nutrition','Studies'],
          time:'Dec 19, 2024'
        },
        btnConfig: {
          link: ''
        }
      },{
        type: 'img2',
        content: {
          img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
          title: 'The Future of Longevity Medicine: Breakthroughs from 2024',
          taglist: ['News', 'Nutrition','Studies'],
          time:'Dec 19, 2024'
        },
        btnConfig: {
          link: ''
        }
      }]
    },
  ])


  useEffect(() => {
    window.scrollTo(0,0)
  }, [location?.pathname]);
  
  useEffect(()=>{
    if(openDetailBox){
      setDetailBoxStyle({
        transform: 'translateY(0) scaleY(1)',
        opacity: 1
      })
      
    }else{
      setDetailBoxStyle({})
      setSelectBtn('')
    }
  },[openDetailBox])

  // 获取商品列表
  const getProductListFn = async () =>{
    let update = {
      page: 1,
      limit: 2,
      prodType: '0',
      prodStatus: '1',
    }
    let res = await getProductList(update)
    console.log(res)
    if(res?.msg === 'success'){
      headerBtnList[0].list = []
      let data = res?.data.map((e,i)=>{
        let item = {
          type: 'goods',
          content:{
            title: e.prodName,
            description: e.description,
            img: e.prodImg1,
            imgHover: e.prodImg2,
            // star: 4.4,
            // commentCount: 2813,
            bestseller: false,
            tag: false
          },
          btnConfig:{
            link:`/shopDetail?id=${e.id}`,
          }
        }

        if(i <= 1){
          headerBtnList[0].list.push(item)
        }
        return item
      })
      console.log(data)
      setHeaderBtnList(()=> headerBtnList)
    }
  }
  // 获取文章列表
  const getBlogListFn = async () =>{
    let update = {
      page: 1,
      limit: 100,
      status: 1,
      // categoryType: 1
    }
    let res = await getBlogList(update)
    console.log('BlogList', res?.data)
    if(res?.msg === 'success'){
      headerBtnList[2].list = []
      let data = res?.data.map((e,i)=>{
        // console.log(e)
        const now = new Date(e.publishedTime);
        const Y = now.getFullYear();
        const M = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
        const D = String(now.getDate()).padStart(2, '0');
        const h = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        const s = String(now.getSeconds()).padStart(2, '0');

        let item = {
          type: 'img2',
          content: {
            // img: <img src={e.coverImage} style={{width: '100%',borderRadius:5}}/>,
            img: <div style={{width: '100%',height:'20vh',background: `url(${e.coverImage}) no-repeat center center/cover`}}></div>,
            title: e.title,
            // taglist: ['News', 'Nutrition','Studies'],
            time: `${Y}-${M}-${D} ${h}:${m}:${s}`
          },
          btnConfig: {
            link: e.articleUrl? e.articleUrl:`/aBoutDetail?id=${e.id}`,
            linkType: e.articleUrl? '_blank':''
          }
        }
        if(i <= 1){
          headerBtnList[2].list.push(item)
        }
        return item
      })
      // console.log(res?.data)
      setHeaderBtnList(()=> headerBtnList)
    }
  }
  useEffect(()=>{
    getProductListFn()
    getBlogListFn()
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  
  const genExtra = () => (
    <PlusOutlined
      style={{fontSize: 32}}
      onClick={(event) => {
        // If you don't want click extra trigger collapse, you can prevent this:
        console.log(123)
      }}
    />
  );
  const title = (text) =>(
    <div style={{ fontSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)', color:'#000' }}>
      {text}
    </div>
  )
  const childrenList = (data)=>{
    return (
      <List
        bordered
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item) => (
          <List.Item 
            style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'}} 
            onClick={()=> {
              navigate(item.link, { state: { menu:item.name } })
              setOpen(false)
            }}
          >
            {item.name}
          </List.Item>
        )}
      />
    )
  }
  const questionsData = [{
    key: '1',
    label: title('商品'),
    children: childrenList([
      {name: '全部商品',link: '/shop'},
      {name: '补充剂',link: '/shop'},
    ]),
    showArrow: false,
    extra: genExtra(),
  },
  {
    key: '2',
    label: title('科学'),
    children: childrenList([
      {name:'前往科学',link: '/science'},
      {name:'研究',link: '/studies'},
    ]),
    showArrow: false,
    extra: genExtra(),
  },
  {
    key: '3',
    label: title('关于'),
    children: childrenList([{
      name:'论文',
      link: '/Blog'
    }]),
    showArrow: false,
    extra: genExtra(),
  }];

  return (
    <div>
      {!isLoginPage? 
        <Header style={headerStyle}>
          <Row justify="space-between" style={{width:'100%',maxWidth:1440, background: '#fff'}} align="middle">
            <Col span={width > 770? 6:4} style={{height: '100%'}} >
              <div 
                style={{width: 'max-content',height: '100%', display:'flex', justifyContent:'start', alignItems: 'center'}} 
                onMouseLeave={()=> setOpenDetailBox(false)}
              >
                {width > 770? 
                  headerBtnList.map((e,i)=>{
                    return (
                      <span 
                        key={i}
                        className="header-btn" 
                        onClick={()=> {
                          navigate(e.link)
                        }}
                        onMouseEnter={()=> {
                          setOpenDetailBox(true)
                          setSelectBtn(e.name)
                        }}
                      >{e.name}</span>
                    )
                  })
                  :
                  <div>
                    <MenuOutlined 
                      style={{fontSize: 26}} 
                      onClick={()=> {
                        setOpen(true)
                        console.log(123)
                      }}
                    />
                  </div>
                }
              </div>
            </Col>

            <Col span={width > 770? 10:14} style={{fontSize:26}} onClick={()=> navigate('/')}>
              <img style={{height: 64, cursor: 'pointer'}} src={require('../../image/logo.png')} alt="" />
            </Col>
            
            {width > 770? 
              <Col span={6} style={{display:'flex', justifyContent:'end'}}>
                {/* <span className="header-btn">Account</span>
                <span className="header-btn">Longevity Game</span>
                <ShoppingOutlined /> */}
              </Col>
              :
              <Col span={4} style={{display:'flex', justifyContent:'end'}}>
                {/* <ShoppingOutlined style={{fontSize: 26}}/> */}
              </Col>
            }
            
          </Row>

          <div className="header-detail-box" style={detailBoxStyle} onMouseEnter={()=> setOpenDetailBox(true)} onMouseLeave={()=> setOpenDetailBox(false)}>
            <Row justify="space-between" className="header-detail-content-box" align="top">
              <Col span={8} style={{padding:'0 16px'}}>
                <Divider style={{ borderColor: '#272724', margin:'0 0 15px 0' }} />
                {headerBtnList.map((e)=>{
                  if(e.name === selectBtn){
                    return (e.childrens.map((E,I)=>{
                      return (
                        <div key={I} className="child-btn" onClick={()=> {
                          navigate(E.link, { state: { menu:E.name } })
                          setOpenDetailBox(false)
                        }}>{E.name}</div>
                      )
                    }))
                  }
                })}
              </Col>
              {/* <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/> */}
              {headerBtnList.map((e)=>{
                if(e.name === selectBtn){
                  return (e.list.map((E,I)=>{
                    return (
                      <Col key={I} span={8} style={{padding:'0 16px'}} onClick={()=> {
                        setOpenDetailBox(false)
                      }}>
                        <CardDom type={E.type} content={E.content} btnConfig={E.btnConfig}/>
                      </Col>
                    )
                  }))
                }
              })}
            </Row>
          </div>
        </Header>
        :
        ''
      }

      <Outlet /> {/* 渲染匹配的子路由组件 */}

      {!isLoginPage?
        <Footer style={footerStyle}>
          <div className="footer-box" style={width > 770? {}:{padding:'0 25px'}}>
            <div className="footer-content-box">
              {/* {width > 770? 
                <div className="footer-content-top">
                  <div style={{width: '30%'}}>
                    <div>知识就是力量</div>
                    <div style={{color: 'rgba(0,0,0,0.54)'}}>注册账号，获取最新消息</div>  
                  </div>

                  <div style={{width: '50%'}}>
                    <div className="signUp-box">
                      <Input 
                        style={{padding: '0 20px 0 0', fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)'}} 
                        placeholder="Borderless" 
                        variant="borderless" 
                      />
                      <div style={{minWidth: 150}}>Sign up <ArrowRightOutlined /></div>
                    </div>
                    <div style={{fontSize:14, marginTop: 10}}>msg</div>
                  </div>
                </div>
                :
                <div className="footer-content-top" style={{display: 'block'}}>
                  <div style={{width: '100%'}}>
                    <div>知识就是力量</div>
                    <div style={{color: 'rgba(0,0,0,0.54)'}}>注册账号，获取最新消息</div>  
                  </div>

                  <div style={{width: '100%', marginTop: 20}}>
                    <div className="signUp-box">
                      <Input 
                        style={{padding: '0 20px 0 0', fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)'}} 
                        placeholder="Borderless" 
                        variant="borderless" 
                      />
                      <div style={{minWidth: 150}}>Sign up <ArrowRightOutlined /></div>
                    </div>
                    <div style={{fontSize:14, marginTop: 10}}>msg</div>
                  </div>
                </div>
              } */}
              
              
              {/* 目录路径 */}
              {width > 770?
                <div style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'}}>
                  <Row>
                    {headerBtnList.map((e)=>{
                      return (
                        <Col span={6} key={e.name}>
                          <div style={{marginBottom: 10, fontWeight: 700}}>
                            {e.name}
                          </div>
                          {e.childrens.map(E=>{
                            return (
                              <div key={E.name} style={{padding: '10px 0', fontWeight: 600}}>
                                {E.name}
                              </div>
                            )
                          })}
                        </Col>
                      )
                    })}

                    <Col span={6}>
                      <div style={{marginBottom: 10, fontWeight: 700}}>支持</div>
                      <div style={{padding: '10px 0', fontWeight: 600}}>帮助中心</div>
                      <div style={{padding: '10px 0', fontWeight: 600}}>会员制营销</div>
                    </Col>
                  </Row>
                </div>
                :
                <Collapse items={questionsData} bordered={false} />
              }

              <div className="icon-box">
                <div><InstagramOutlined style={{fontSize:20, color: 'rgba(0,0,0,0.54)'}} /></div>
                <div><FacebookFilled style={{fontSize:20, color: 'rgba(0,0,0,0.54)'}} /></div>
                <div><YoutubeFilled style={{fontSize:20, color: 'rgba(0,0,0,0.54)'}} /></div>
                <div><TikTokOutlined style={{fontSize:20, color: 'rgba(0,0,0,0.54)'}} /></div>
              </div>

              <div style={{fontSize: 14, color: 'rgba(0,0,0,0.54)', padding: '20px 0', borderTop: '1px solid rgba(0,0,0,0.12)', borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
                科学验证：配方经权威机构临床验证，有效提升NAD+水平，实验数据支撑健康功效。
                安全认证：通过XX国际安全认证，严格把控产品品质。
                (实验数据待补充)
              </div>

              <div style={{marginTop: 20}}>
                <div>
                  <span style={{marginRight: 20}}>© 2025</span>
                  <span style={{marginRight: 20}}>Terms & Conditions</span>
                  <span style={{marginRight: 20}}>Privacy Policy</span>
                </div>
                {/* <div><AlipayCircleFilled /></div> */}
              </div>
            </div>
          </div>
        </Footer>
        :
        ''
      }

      
      {width < 770?
        <Drawer
          width={'100%'}
          placement={'left'}
          closable={false}
          onClose={()=> setOpen(false)}
          open={open}
        >
          <Header 
            style={{
              width: '100%',
              height: 64,
              padding: 0,
              color: '#000',
              textAlign: 'center',    
              lineHeight: '24px',
              background: "#fff",
              display: 'flex',
              alignItem:"center",
              justifyContent: 'center',
              position:'relative',
              zIndex: 999
            }}
          >
            <Row justify="space-between" style={{width:'100%',padding:'0'}} align="middle">
              <Col span={6} style={{height: '100%'}} >
                <div 
                  style={{width: 'max-content',height: '100%', display:'flex', justifyContent:'start', alignItems: 'center'}} 
                  onMouseLeave={()=> setOpenDetailBox(false)}
                >
                  <div>
                    <CloseOutlined  
                      style={{fontSize: 26}} 
                      onClick={()=> {
                        setOpen(false)
                        console.log(123)
                      }}
                    />
                  </div>
                </div>
              </Col>

              <Col span={10} style={{fontSize:26, cursor: 'pointer'}} onClick={()=> navigate('/')}>
                <img style={{height: 64, cursor: 'pointer'}} src={require('../../image/logo.png')} alt="" />
              </Col>
              
              <Col span={6} style={{display:'flex', justifyContent:'end'}}>
                {/* <ShoppingOutlined style={{fontSize: 26}}/> */}
              </Col>
              
            </Row>
          </Header>

          <div className="menu-collapse">
            <Collapse items={questionsData} bordered={false} />
          </div>
        </Drawer>
        :
        ''
      }
    </div>
  );
};

export default BaseLayout;